import React from 'react';

interface TableRow {
  firstName: string;
  lastName: string;
  status: 'Paid' | 'Pending';
  amount: number;
}

interface TableProps {
  rows: any[];
  heading: string;
  showActionButton?: boolean;
  handlePaymentClick?: (row: any) => void;
}



const BillTable: React.FC<TableProps> = ({ rows, heading, showActionButton = true, handlePaymentClick }) => {

  return (
    <div className="overflow-x-auto w-full">
      <h2 className="text-2xl font-bold mb-4">{heading}</h2>
      <table className="min-w-full bg-white border border-gray-200 w-full">
        <thead>
          <tr className="bg-gray-100">
            <th className="py-2 px-4 border-b text-center">First Name</th>
            <th className="py-2 px-4 border-b text-center">Last Name</th>
            <th className="py-2 px-4 border-b text-center">Status</th>
            <th className="py-2 px-4 border-b text-center">Amount</th>
            {showActionButton && <th className="py-2 px-4 border-b text-center">Action</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            let jsonData;
            try{
                jsonData = JSON.parse(row.jsonData);
            } catch(e){
                jsonData = row.jsonData;
            }
            const patientName = jsonData?.patientName;
            const firstName = patientName?.split(" ")?.[0];
            const lastName = patientName?.split(" ")?.[1];

            return (
            <tr key={index} className="hover:bg-gray-50">
              <td className="py-2 px-4 border-b text-center">{row.firstName || firstName}</td>
              <td className="py-2 px-4 border-b text-center">{row.lastName || lastName}</td>
              <td className="py-2 px-4 border-b text-center">{row.status}</td>
              <td className="py-2 px-4 border-b text-center">${row.amount.toFixed(2)}</td>
              { showActionButton && <td className="py-2 px-4 border-b text-center">
                <button
                  className="bg-blue-500 text-white py-1 px-3 rounded"
                  onClick={() => handlePaymentClick?.(row)}
                >
                  Pay Now
                </button>
              </td>
              }
            </tr> 
          )
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BillTable;
